import { render } from "./TicketIcon.vue?vue&type=template&id=36475bfa"
import script from "./TicketIcon.vue?vue&type=script&lang=js"
export * from "./TicketIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__